var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTotalImpression(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 168.93 164.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#19cffc;}.cls-2{fill:#4ab8f7;}.cls-3{fill:#ffcdbe;}.cls-4{fill:#faa68e;}.cls-5{fill:#ff9a83;}.cls-6{fill:#6ad3aa;}.cls-7{fill:#ffe079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_08-rateing",
    "data-name": " 08-rateing"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.93,
    y: 93.63,
    width: 17.5,
    height: 45.5,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.18,135.63V97.13a3.5,3.5,0,0,1,3.5-3.5H38.43a3.5,3.5,0,0,0-3.5,3.5v38.5a3.51,3.51,0,0,0,3.5,3.5h5.25A3.51,3.51,0,0,1,40.18,135.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.93,97.13h19.25a5.25,5.25,0,0,1,0,10.5h1.75a5.25,5.25,0,0,1,0,10.5h-1.75a5.25,5.25,0,0,1,0,10.5h-3.5a5.25,5.25,0,0,1,0,10.5H66.43a10.84,10.84,0,0,1-7-3.5h-7V97.13h10.5l4.81-3.85a10.49,10.49,0,0,0,3.94-8.19V74.38c6.94,0,9.95,2.82,11.25,5.25a8.22,8.22,0,0,1,1,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.68,79.63a8.22,8.22,0,0,1,1,3.5v8.75a5.25,5.25,0,0,0,5.25,5.25v-14a8.22,8.22,0,0,0-1-3.5c-1.3-2.43-4.31-5.25-11.25-5.25v.7A9.49,9.49,0,0,1,77.68,79.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.53,51.29l-5.59,8.38,2.79,11.18-11.18-5.59-11.18,5.59,2.8-11.18-5.59-8.38H121l5.59-8.39,5.59,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.4,51.29l-5.59,8.38,2.8,11.18L87.43,65.26,76.25,70.85,79,59.67l-5.59-8.38h8.39l5.59-8.39L93,51.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.28,51.29l-5.59,8.38,2.79,11.18L48.3,65.26,37.12,70.85l2.8-11.18-5.59-8.38h8.38L48.3,42.9l5.59,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.43,102.38h21a5.25,5.25,0,0,1-5.25,5.25H87.43v-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.43,123.38h21a5.25,5.25,0,0,1-5.25,5.25H87.43v-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M87.43,112.88h22.75a5.25,5.25,0,0,1-5.25,5.25H87.43v-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.68,133.88H66.43a10.84,10.84,0,0,1-7-3.5h-7v5.25h7a10.84,10.84,0,0,0,7,3.5H99.68a5.25,5.25,0,0,0,5.25-5.25Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalImpression);
export default __webpack_public_path__ + "static/media/TotalImpression.0b20232faf45d6478ce5c6156bc3a73e.svg";
export { ForwardRef as ReactComponent };